import { Icon } from '../ui/index.js';
import { useBlur } from './BlurContext.js';

export function BlurToggle() {
  const { blurred, toggle } = useBlur();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={blurred ? 'Disattiva privacy blur' : 'Attiva privacy blur'}
      aria-pressed={blurred}
      title={blurred ? 'Mostra immagini' : 'Sfoca immagini'}
      className="flex h-10 w-10 items-center justify-center rounded-xl border border-outline bg-surface-container-lowest text-on-surface-variant transition-all hover:border-on-surface-variant/40 hover:text-cyan"
    >
      <Icon name={blurred ? 'blur_on' : 'blur_off'} className="text-base" />
    </button>
  );
}
